var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text"},[_c('h3',[_vm._v(_vm._s(_vm.$t("pages.other-integrations.subtitle1")))]),_c('p',[_vm._v(_vm._s(_vm.$t("pages.other-integrations.text1")))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integrations"},[_c('img',{staticClass:"integration-img",attrs:{"src":require("@/assets/integrations.png"),"alt":"Integrations"}})])
}]

export { render, staticRenderFns }